import { useEffect } from "react";

const SESSION_DURATION = 60 * 60 * 1000; // 1 hour

function useSessionTimeout() {
  useEffect(() => {
    const checkSession = () => {
      const loginTime = localStorage.getItem("loginTime");

      if (!loginTime) return;

      const now = Date.now();
      const diff = now - parseInt(loginTime, 10);

      if (diff > SESSION_DURATION) {
        // Clear storage
        localStorage.clear();

        // Optional: clear cookies
        document.cookie.split(";").forEach((cookie) => {
          document.cookie =
            cookie.trim().split("=")[0] +
            "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
        });

        // Reload app
        window.location.reload();
      }
    };

    // Check immediately
    checkSession();

    // Check every minute
    const interval = setInterval(checkSession, 60 * 1000);

    return () => clearInterval(interval);
  }, []);
}

export default useSessionTimeout;